export enum Action {
  SetFinancingValue = 'page/drp/SET_FINANCING_VALUE',
  SetCoApplicantValue = 'page/drp/SET_CO_APPLIANT_VALUE',
  ResetApplicant = 'page/drp/RESET_APPLIANT',
  ResetCoApplicant = 'page/drp/RESET_CO_APPLIANT',
}
